export default "/fonts/RV-Harmonia-Regular.eot?31803f896563082ace121d66386a045c";